import { render, staticRenderFns } from "./DiningOptionModal.vue?vue&type=template&id=1374093c&scoped=true"
import script from "./DiningOptionModal.vue?vue&type=script&lang=js"
export * from "./DiningOptionModal.vue?vue&type=script&lang=js"
import style0 from "./DiningOptionModal.vue?vue&type=style&index=0&id=1374093c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1374093c",
  null
  
)

export default component.exports